import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import {
  SwitchCompanyResponseDto,
  SwitchConfigurationService,
} from '../../services/wealthlane-customer-services';
import { OptionType } from '../../types/common';
import {
  CompanySsoConfigurationService,
  Wealthlane_Dtos_SsoProvider_CreateUpdateCompanySsoConfigurationDto,
} from '../../services/wealthlane-identity-services';
import { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../../services/wealthlane-award-services';

const usePostCompanySso = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onSuccess: () => void
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload?: Wealthlane_Dtos_SsoProvider_CreateUpdateCompanySsoConfigurationDto) => {
      const response = await handleRequest(
        CompanySsoConfigurationService.postApiIdentityApiAppCompanySsoConfiguration(payload)
      );
      return response;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('getCompanySsoConfigList');
        onSuccess();
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostCompanySso;
